import postcodeValidatorFunc from "uk-postcode-validator";
import { createValidator } from "not-valid";

export const isPostcodeValid = postcodeValidatorFunc;
export const postcodeValidationErrorMessage = "Postcode is not valid";
export const postcodeValidator = createValidator(isPostcodeValid, postcodeValidationErrorMessage);
